import React from "react";
import { Box, Container, Link, Typography, Divider, useTheme } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const Footer = () => {
  const theme = useTheme();
  
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: "auto",
        backgroundColor: "background.paper",
        borderTop: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} Microcumulus
          </Typography>
          
          <Box
            sx={{
              display: "flex",
              gap: 3,
            }}
          >
            <Link
              component={RouterLink}
              to="/privacy"
              color="primary"
              underline="hover"
              variant="body2"
            >
              Privacy Policy
            </Link>
            <Link 
              component={RouterLink}
              to="/tos"
              color="primary"
              underline="hover"
              variant="body2"
            >
              Terms of Service
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;